/** Libellés d'édition par module — alignés sur @itaas/edu-editions et @itaas/hospitol-editions. */
const MODULE_EDITION_LABELS: Record<string, Record<string, string>> = {
  edu: {
    essential: "ITaaS Edu Essential",
    standard: "ITaaS Edu Standard",
    premium: "ITaaS Edu Premium",
    enterprise: "ITaaS Edu Enterprise",
    starter: "ITaaS Edu Standard",
    professional: "ITaaS Edu Standard",
  },
  hospitol: {
    care: "ITaaS Hospitol Care",
    clinic: "ITaaS Hospitol Clinic",
    full: "ITaaS Hospitol Full",
  },
};

export function resolveModuleEditionLabel(
  moduleId: string,
  edition: string | null | undefined,
): string | undefined {
  const normalizedModule = moduleId.trim().toLowerCase();
  const normalizedEdition = edition?.trim().toLowerCase();
  if (!normalizedEdition) return undefined;
  return MODULE_EDITION_LABELS[normalizedModule]?.[normalizedEdition];
}

export function resolveModuleEditionLabels(
  moduleEditions: Record<string, string> | null | undefined,
): Record<string, string> {
  if (!moduleEditions) return {};
  const labels: Record<string, string> = {};
  for (const [moduleId, edition] of Object.entries(moduleEditions)) {
    const label = resolveModuleEditionLabel(moduleId, edition);
    if (label) labels[moduleId] = label;
  }
  return labels;
}
